module.exports = __webpack_public_path__ + "847065204ca6b78288344efb232cff1f.png";